
import { Options, Vue } from 'vue-class-component'
import { CountUp } from 'countup.js'
import { Odometer } from 'odometer_countup';
import * as echarts from 'echarts';
import { mapState, mapMutations } from 'vuex'

let myChart, option;
let gdpList = [
  {
    year: 1992,
    country: '美国,日本,德国,法国,意大利,英国,西班牙,加拿大,俄罗斯,中国',
    count: '6.52,3.98,2.13,1.4,1.32,1.18,0.63,0.59,0.46,0.42',
  },
  {
    year: 1994,
    country: '美国,日本,德国,法国,英国,意大利,加拿大,中国,墨西哥,西班牙',
    count: '7.29,5.00,2.21,1.39,1.14,1.10,0.58,0.56,0.55,0.53',
  },
  {
    year: 1996,
    country: '美国,日本,德国,法国,英国,意大利,中国,巴西,西班牙,加拿大',
    count: '8.07,4.92,2.50,1.61,1.42,1.31,0.86,0.85,0.64,0.63',
  },
  {
    year: 2000,
    country: '美国,日本,德国,英国,法国,中国,意大利,加拿大,墨西哥,巴西',
    count: '10.25,4.97,1.95,1.67,1.37,1.21,1.15,0.74,0.742,0.65',
  },
  {
    year: 2005,
    country: '美国,日本,德国,英国,中国,法国,意大利,加拿大,西班牙,韩国',
    count: '13.04,4.83,2.85,2.54,2.29,2.20,1.86, 1.17,1.15,0.93',
  },
  {
    year: 2006,
    country: '美国,日本,德国,中国,英国,法国,意大利,加拿大,西班牙,巴西',
    count: '13.82,4.60,2.99,2.75,2.71,2.32,1.95,1.32,1.26,1.11',
  },
  {
    year: 2007,
    country: '美国,日本,中国,德国,英国,法国,意大利,西班牙,加拿大,巴西',
    count: '14.47,4.58,3.55,3.43,3.09,2.66,2.21,1.47,1.47,1.40',
  },
  {
    year: 2010,
    country: '美国,中国,日本,德国,法国,英国,巴西,意大利,印度,加拿大',
    count: '15.05,6.09,5.76,3.40,2.65,2.49,2.21,2.14,1.68,1.62',
  },
  {
    year: 2023,
    country: '美国,中国,德国,日本,印度,英国,法国,意大利,巴西,加拿大',
    count: '27.36,17.79,4.46,4.21,3.55,3.34,3.03,2.25,2.17,2.14',
  },
];
let startYear = 1992;
@Options({
  name: 'Gdp',
  components: {},
  props: {},
  data() {
    return {
      isShowGdpIntro: false,
      isShowGdpChart: false,
      gdpIntroStep: 0,
      gdpEndStep: 0,
      flags: [],
      year: 1992,
    }
  },
  computed: {},
  mounted() {
    this.init();
    this.chart();
    this.SET_MUSICURL('https://yunyingcdn.thecover.cn/o_1i919n4m11sqfk01tl11dk7anb9.mp3')
  },
  methods: {
    ...mapMutations(['SET_MUSICURL']),
    init() {
      const _this = this;
      const vw = window.innerWidth;
      const vh = window.innerHeight;

      let isShowGdpIntro = false;
      let showGdpEndStep = 0;
      let isShowChart = false;

      window.addEventListener('scroll', () => {
        const gdpIntroTop = document.querySelector('.gdb-content')?.getBoundingClientRect().top;
        if (gdpIntroTop && gdpIntroTop < vh / 2) {
          isShowGdpIntro = true;
          _this.isShowGdpIntro = true;
          /* _this.$nextTick(() => {
            setTimeout(() => {
              _this.gxgdpCount();
            }, 500);
          }); */
        }

        if (!isShowChart && gdpIntroTop && gdpIntroTop < 0) {
          isShowChart = true;
          this.isShowGdpChart = true;
          this.gdpIntroStep = 1;
          this.$nextTick(() => {
            this.setChart();
          });
        }

        if (showGdpEndStep < 2) {
          const gdpEndTop = document.querySelector('.gdp-end')?.getBoundingClientRect().top;
          if (gdpEndTop && gdpEndTop < vh / 2 && gdpEndTop > vh / 3) {
            _this.gdpEndStep = 1;
          }
          if (gdpEndTop && gdpEndTop < vh / 3) {
            _this.gdpEndStep = 2;
          }
        }

      }, false)
    },
    // 贡献GDP
    gxgdpCount() {
      new CountUp('gxgdp', 30, {
        suffix: '%',
      }).start();
    },
    chart() {
      const chartDom = document.getElementById('gdp-chart');
      myChart = echarts.init(chartDom);

      option = {
        xAxis: {
          type: 'category',
          data: gdpList[0].country.split(','),
          axisLine: { // 关闭轴线显示
            show: false
          },
          axisTick: { // 关闭刻度线显示
            show: false
          },
          axisLabel: {
            show: false,
          },
          animationDuration: 300,
          animationDurationUpdate: 300
        },
        yAxis: {
          type: 'value',
          max: 28,
          axisLine: { // 关闭轴线显示
            show: false
          },
          axisTick: { // 关闭刻度线显示
            show: false
          },
          splitLine: { // 关闭分割线显示
            show: false
          },
          axisLabel: { // 关闭标签显示
            show: false
          }
        },
        series: [
          {
            data: gdpList[0].count.split(','),
            type: 'bar',
            itemStyle: {
              color(param) {
                const countryColor = {
                  '美国': '#004286',
                  '日本': '#A2A1A1',
                  '德国': '#383838',
                  '法国': '#FFFFFF',
                  '意大利': '#009247',
                  '英国': '#DF7B83',
                  '西班牙': '#FFC40E',
                  '加拿大': '#a90076',
                  '俄罗斯': '#0039A6',
                  '中国': '#DE2910',
                  '韩国': '#2B1D73',
                  '墨西哥': '#006746',
                  '印度': '#FFAF60',
                }
                return countryColor[param.name] || '#5470c6';
              }
            },
            label: {  
              show: true,
              position: 'top',
              formatter: '{b}',
              fontFamily: 'systm',
              fontSize: 9,
            }
          }
        ],
        animationDuration: 0,
        animationDurationUpdate: 1000,
        animationEasing: 'linear',
        animationEasingUpdate: 'linear',
      };

      option && myChart.setOption(option);
    },
    setChart() {
      let index = 1;
      let gdpIntr = setInterval(() => {
        if (index >= gdpList.length) {
          clearInterval(gdpIntr);
          return;
        }
        option.xAxis.data = gdpList[index].country.split(',');
        this.flags = gdpList[index].country.split(',');
        this.year = gdpList[index].year;
        this.gdpYear();
        option.series[0].data = gdpList[index].count.split(',');
        myChart.setOption(option);
        index++;
      }, 1300);
    },
    gdpYear() {
      const year = this.year;
      if (year === 2010) {
        this.gdpIntroStep = 2;
      }

      if (year === 2023) {
        this.gdpIntroStep = 3;
        this.$nextTick(() => {
          this.gxgdpCount();
        });
      }
      new CountUp('gdp-year', year, {
        useGrouping: false,
        startVal: startYear,
        duration: 1,
        // plugin: new Odometer({ duration: 1, lastDigitDelay: 0 }),
      }).start();
      startYear = year;
    },
    back () {
      window.location.reload()
    }
  },
})
export default class Gdp extends Vue {

}
